module.exports = __webpack_public_path__ + "static/sea-dragon-22bbfcc9679308cffb75472de8980398.png";